import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'
import { RadioProps } from '@ui/components/Radio'

import { NameDto } from '@model/NameDto'

interface Props {
  title: string
  name: string
  description?: string
  onSelect: (value: string) => void
  options?: RadioProps[]
  canSearch?: boolean

  initialValue?: string
  simpleOptions?: (string | number | NameDto<string | number>)[]
}

export const RadioModal: BaseModalType<Props> = (props) => {
  const {
    close,
    title,
    name,
    description,
    onSelect,
    initialValue = '',
    options,
    canSearch,
    simpleOptions,
  } = props
  const { t } = useTranslation()
  const [search, setSearch] = useState('')

  const parsedOptions =
    options ??
    simpleOptions?.map((option) =>
      typeof option === 'object'
        ? ({
            label: option.name,
            value: option.id.toString(),
          } as RadioProps)
        : ({
            label: option,
            value: option.toString(),
          } as RadioProps)
    ) ??
    []

  const searchedOptions = parsedOptions.filter((x) =>
    x.label?.toLowerCase().includes(search.toLowerCase())
  )

  const handleConfirm = (value: string) => {
    onSelect(value)
    close()
  }

  return (
    <Modal>
      <Modal.Header
        search={
          canSearch
            ? {
                onChange: setSearch,
                value: search,
              }
            : undefined
        }
      >
        {title}
      </Modal.Header>
      <Modal.Body>
        {description && <Modal.Body.Text>{description}</Modal.Body.Text>}
        <Modal.Body.Input.Radio
          value={initialValue}
          name={name}
          options={searchedOptions}
          onChange={handleConfirm}
        />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
